import { gql } from '@apollo/client'
import { CONTENT_BLOCK_PREVIEW_FRAGMENT } from '../ContentBlocks/contentBlockQueries'

export const GET_PAGES = gql`
  query GET_PAGES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [PageOrderByWithRelationInput!]
  ) {
    findManyPage(
      where: {
        OR: [
          { code: { contains: $searchTerm, mode: insensitive } }
          {
            page_profiles: {
              some: { title: { contains: $searchTerm, mode: insensitive } }
            }
          }
        ]
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      code
      published
      arrangement
      page_profiles {
        id
        language
        slug
        title
        subtitle
      }
      content_blocks {
        id
      }
      createdAt
      updatedAt
    }
    findManyPageCount(
      where: {
        OR: [
          { code: { contains: $searchTerm, mode: insensitive } }
          {
            page_profiles: {
              some: { title: { contains: $searchTerm, mode: insensitive } }
            }
          }
        ]
      }
    )
  }
`

export const GET_PAGES_TREE = gql`
  query GET_PAGES_TREE {
    findManyPage(orderBy: { arrangement: asc }) {
      id
      code
      published
      arrangement
      parentId
      page_profiles {
        id
        language
        slug
        title
      }
    }
  }
`

export const GET_ALL_PAGES_FOR_PICKER = gql`
  query GET_ALL_PAGES_FOR_PICKER {
    findManyPage {
      id
      parentId
      arrangement
      page_profiles {
        language
        title
        slug
      }
    }
  }
`

export const GET_PAGE = gql`
  ${CONTENT_BLOCK_PREVIEW_FRAGMENT}
  query GetPage($id: String!) {
    findUniquePage(where: { id: $id }) {
      id
      code
      published
      chromeless
      private
      arrangement
      hero_imageId
      hero_display
      hero_height_value
      hero_height_unit
      hero_video_link
      parentId
      hero_image {
        id
        src
      }
      cta_new_tab
      cta_link_page_id
      cta_link_type
      cta_link_category {
        id
      }
      page_profiles {
        id
        language
        slug
        title
        subtitle
        meta_description
        cta_label
        cta_link
      }
      content_blocks(orderBy: { arrangement: asc }) {
        ...ContentBlockPreviewFields
        arrangement
        video_type
        video_link
      }
      tags {
        id
        page_tag_profiles {
          id
          language
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`

export const CREATE_PAGE = gql`
  mutation CREATE_PAGE(
    $code: String!
    $published: Boolean
    $chromeless: Boolean
    $private: Boolean
    $arrangement: Int
    $hero_imageId: Int
    $hero_display: HeroDisplay
    $hero_height_value: Int
    $hero_height_unit: HeroHeightUnit
    $hero_video_link: String
    $parentId: String
    $page_profiles: [PageProfileCustomInput!]
    $tag_ids: [Int!]
    $cta: CtaLinkInput
  ) {
    createNewPage(
      code: $code
      published: $published
      chromeless: $chromeless
      private: $private
      arrangement: $arrangement
      hero_imageId: $hero_imageId
      hero_display: $hero_display
      hero_height_value: $hero_height_value
      hero_height_unit: $hero_height_unit
      hero_video_link: $hero_video_link
      parentId: $parentId
      page_profiles: $page_profiles
      tag_ids: $tag_ids
      cta: $cta
    ) {
      id
      tags {
        id
      }
    }
  }
`

export const UPDATE_PAGE = gql`
  mutation UPDATE_PAGE(
    $where: PageWhereUniqueInput!
    $code: String
    $published: Boolean
    $chromeless: Boolean
    $private: Boolean
    $arrangement: Int
    $hero_imageId: Int
    $hero_display: HeroDisplay
    $hero_height_value: Int
    $hero_height_unit: HeroHeightUnit
    $hero_video_link: String
    $parentId: String
    $page_profiles: [PageProfileCustomInput!]
    $content_block_ids: [Int!]
    $tag_ids: [Int!]
    $cta: CtaLinkInput
  ) {
    updateExistingPage(
      where: $where
      code: $code
      published: $published
      chromeless: $chromeless
      private: $private
      arrangement: $arrangement
      hero_imageId: $hero_imageId
      hero_display: $hero_display
      hero_height_value: $hero_height_value
      hero_height_unit: $hero_height_unit
      hero_video_link: $hero_video_link
      parentId: $parentId
      page_profiles: $page_profiles
      content_block_ids: $content_block_ids
      tag_ids: $tag_ids
      cta: $cta
    ) {
      id
      code
      published
      chromeless
      private
      arrangement
      hero_imageId
      hero_display
      hero_height_value
      hero_height_unit
      hero_video_link
      hero_image {
        id
        src
      }
      cta_new_tab
      cta_link_page_id
      page_profiles {
        id
        language
        slug
        title
        subtitle
        meta_description
        cta_label
        cta_link
      }
      content_blocks {
        id
      }
      tags {
        id
      }
    }
  }
`

export const DELETE_MANY_PAGES = gql`
  mutation DELETE_PAGES($ids: [String!]!) {
    deleteManyPage(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const PAGE_DELETE_INFO = gql`
  query PageDeleteInfo($id: String!) {
    pageDeleteInfo(id: $id) {
      childCount
      subtreeCount
      referenceCount
    }
  }
`

export const DELETE_SINGLE_PAGE = gql`
  mutation DeleteSinglePage($id: String!, $children: String) {
    deleteSinglePage(id: $id, children: $children) {
      id
    }
  }
`
